export enum ManagedErrorCode {
	badRequest = 'badRequest', // errori nei dati di input
	userRegistrato = 'userRegistrato',
	totQuoteIsNot100 = 'totQuoteIsNot100',
	max100QuotaReale = 'max100QuotaReale',
	quoteNotNull = 'quoteNotNull',
	patrimNetAziendals0 = 'patrimNetAziendals0',
	pensioneNull = 'pensioneNull',
	pensioneConiugeNull = 'pensioneConiugeNull',
	numDipendentiNull = 'numDipendentiNull',
	errGetData = 'errGetData',
	erroreGenReportEPReporter = 'erroreGenReportEPReporter',
	erroreGenReportDownload = 'erroreGenReportDownload',
	activationUserError = 'activationUserError',
	errorEndDate = 'errorEndDate',
  testoRegolaAlreadyExists = 'testoRegolaAlreadyExists',
  knowHowAlreadyExists = 'knowHowAlreadyExists',
  nodoConQuotePatrimoni = 'nodoConQuotePatrimoni',
  ephesoError = 'ephesoError', // --> usare la descrizione ritornata in response senza tradurre (errori calcoli epheso)
  fileNotSafeError = 'fileNotSafeError',
  contattoDossierAlreadyExists = 'contattoDossierAlreadyExists',
  documentoNotFound = 'documentoNotFound',
  noImmobiliCatasto = 'noImmobiliCatasto',
  captchaErrato = 'captchaErrato',
	walletEsistente = 'walletEsistente',
	walletNotFound = 'walletNotFound',
  wordpressUserNotFound = 'wordpress.user_not_found',
  wordpressClientError = 'wordpress.client_error',
  wordpressConnectionError = 'wordpress.connection_error',
  noAuthCondivisione = 'noAuthCondivisione',
  visuraNotFound = 'visuraNotFound',
  visuraSoggettoNonCorrispondente = 'visuraSoggettoNonCorrispondente',
  visuraXmlNonValida = 'visuraXmlNonValida',
  ricercaProvinceNonRiuscita = 'ricercaProvinceNonRiuscita',
	templateNonTrovato = 'templateNonTrovato'
}
